
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13193',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13193",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.717",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9937",
  "foundations-components": "static-1.8463",
  "foundations-components-legacy": "static-1.1488",
  "foundations-theming": "static-1.4753",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.87",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8313",
  "hub-http-shared-msw-handlers": "static-1.10586",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11767",
  "I18n": "static-7.1669",
  "jasmine-runner": "static-1.6733",
  "marketplace-discovery-studio-lib": "static-1.606",
  "marketplace-storefront-base": "static-1.13256",
  "quartz": "static-1.7432",
  "react-dlb": "static-1.88",
  "react-rhumb": "static-1-aeastham-wv-soft-nav-lcp-field-cleanup.2",
  "reactive-variable-buffer-atom": "static-1.3136",
  "reporting-testing-lib": "static-1.10685",
  "reselect": "static-3.10",
  "settings-ui-lib": "static-1.12804",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7602",
  "ui-addon-i18n": "static-1.11427",
  "ui-addon-react-router-dom": "static-1.9818",
  "unified-auth": "static-1.883",
  "unified-auth-core-lib": "static-1.1165",
  "usage-tracker": "static-1.7636",
  "usage-tracker-core": "static-1.7486",
  "customer-data-property-utils": "static-1.8383",
  "hub-http": "static-1.6493",
  "integrations-lib": "static-1.16993",
  "marketplace-ui-common": "static-1.20692",
  "marketplace-ui-install": "static-1.678",
  "property-management-iframe": "static-1.14096",
  "quartz-config": "static-1.1210",
  "quartz-core": "static-1.6651",
  "quartz-routing": "static-1.862",
  "quick-fetch": "static-1.4117",
  "react": "static-7.192",
  "rpc-client-utils": "static-1.4946",
  "ts-schema": "static-1.4279",
  "ui-universal-auth": "static-1.9369",
  "UIComponents": "static-3.8713",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3606",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3709",
  "quartz-webpack": "static-1.3656",
  "bend-plugin-quartz-routing": "static-1.510",
  "ai-components-ui-library": "static-1.9674",
  "codemirror": "static-5.100",
  "foundations-assets": "static-1.5164",
  "pulse": "static-1.909",
  "react-codemirror": "static-1.10920",
  "ui-extensions-preview-lib": "static-1.571",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4732",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2469",
  "framer-motion": "static-1.77",
  "hs-story-utils": "static-1.9706",
  "react-aria": "static-1.71",
  "react-create-root-preference": "static-1.68",
  "react-select-plus": "static-1.110",
  "react-utils": "static-2.5542",
  "react-virtualized": "static-2.105",
  "StyleGuideUI": "static-3.501",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2587",
  "ui-fonts": "static-1.1029",
  "ui-images": "static-2.1239",
  "bend-plugin-foundations-theming": "static-1.3236",
  "foundations-theming-base": "static-1.3738",
  "stylex": "static-1.39",
  "HeadJS": "static-2.794",
  "hs-test-utils-bend-plugin": "static-1.3424",
  "msw": "static-1.39",
  "testing-library": "static-1.157",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.89",
  "jasmine": "static-4.4594",
  "ui-addon-video-player": "static-1.8983",
  "ai-rendering-library": "static-1.11067",
  "chirp-fetch": "static-1.2175",
  "connections-embed-lib": "static-1.1484",
  "copilot-toolkit": "static-1.11820",
  "feedback-loader": "static-1.29781",
  "laboratory-lib": "static-3.7431",
  "marketplace-embed": "static-1.22870",
  "marketplace-ui-details": "static-1.10587",
  "marketplace-ui-reviews": "static-1.20647",
  "marketplace-ui-tracking": "static-1.14862",
  "sanitize-text": "static-1.8434",
  "usage-tracker-multi": "static-1.6050",
  "usage-tracker-session-replay": "static-1.5322",
  "wootric-nps": "static-1.7186",
  "quartz-head": "static-1.1097",
  "web-vitals": "static-1.13",
  "apollo-link-hub-http": "static-2.4936",
  "immer": "static-1.99",
  "immerable": "static-1.4430",
  "highcharts": "static-8.109",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2672",
  "reporting-data": "static-1.68752",
  "cssUtils": "static-1.901",
  "flux-actions": "static-1.366",
  "react-colorpicker": "static-2.10497",
  "react-dnd-compat": "static-1.4898",
  "redux-observable": "static-1.73",
  "ReduxMessenger": "static-2.10650",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7626",
  "icons": "static-2.678",
  "marketplace-ui-apps-core": "static-1.19224",
  "storybook-react": "static-1.38",
  "trellis-story-utils": "static-1.4789",
  "foundations-components-test-utils": "static-1.5946",
  "quartz-i18n": "static-1.1107",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.428",
  "ads-unified-auth-lib": "static-1.1259",
  "google-sheets-integration-lib": "static-1.994",
  "microsoft-drive-auth-lib": "static-1.104",
  "surveymonkey-integration-lib": "static-1.437",
  "slack-ui-library": "static-1.10680",
  "fsm": "static-1.4030",
  "customer-data-objects": "static-1.7971",
  "property-translator": "static-1.5678",
  "hs-locale-management": "static-1.279",
  "frontend-preferences-client": "static-1.8203",
  "hs-promise-utils": "static-1.5877",
  "hubspot-apollo-client": "static-1.5159",
  "integrations-error-boundary-lib": "static-1.14408",
  "integrations-tracking-lib": "static-1.5889",
  "native-integrations-shared-strings": "static-1.8059",
  "sanitize": "static-1.4754",
  "superstore": "static-1.5037",
  "ui-shepherd-react": "static-3.10549",
  "ai-settings-ui-library": "static-1.8300",
  "hub-http-janus": "static-1.875",
  "hubspotter-http": "static-1.4850",
  "immutable-less": "static-1.4930",
  "marketplace-ui-client-types": "static-1.18099",
  "nav-meta": "static-1.30431",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18355",
  "ui-product-approvals-common": "static-1.992",
  "ai-studio-lib": "static-1.12419",
  "hubspot-prosemirror": "static-1.18936",
  "integrations-reconnect-lib": "static-1.457",
  "ui-addon-iframeable": "static-1.9358",
  "ui-addon-integrations-directory-panel": "static-2.8306",
  "ui-product-approvals": "static-1.29097",
  "ui-tool-access": "static-1.10435",
  "inbound-db-properties-service-client": "static-1.4042",
  "property-management-common": "static-1.6384",
  "opentelemetry-fe-types": "static-1.50",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.31",
  "opentelemetry-fe": "static-1.425",
  "quartz-auth": "static-1.1107",
  "quartz-test": "static-1.1107",
  "quartz-tracking": "static-1.811",
  "trellis-components": "static-1.2606",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.356",
  "HubStyle": "static-2.12074",
  "bender-build-tools": "static-1.3425",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22914",
  "ContentUtils": "static-1.69090",
  "customer-data-objects-ui-components": "static-1.13312",
  "sassPrefix": "static-1.173",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.412",
  "batch-promise": "static-1.1824",
  "event-emitter": "static-1.1233",
  "fast-json-patch": "static-1.68",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5739",
  "magpie-types": "static-1.5199",
  "stylex-utils": "static-1.138",
  "trellis-theming": "static-1.1255",
  "avatar-components": "static-1.2766",
  "breeze-engine-core": "static-1.960",
  "breeze-onboarding-components": "static-1.680",
  "customer-data-filters-ui": "static-1.40865",
  "customer-data-reference-ui-components": "static-1.13459",
  "embedded-academy-lib": "static-1.15474",
  "ExportDialog": "static-6.10658",
  "global-styles-ai-lib": "static-1.47",
  "highlight.js": "static-1.84",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42004",
  "reporting-snowflake": "static-1.57369",
  "reporting-ui-components": "static-2.66022",
  "reporting-visualizations": "static-1.60827",
  "trial-components-library": "static-1.14079",
  "ui-addon-teams": "static-1.21887",
  "upgrade-components-lib": "static-1.493",
  "navigation-components": "static-1.18794",
  "breeze-engine-lib": "static-1.1682",
  "simple-logging-lib": "static-1.3331",
  "fail-safe": "static-1.234",
  "app-governance-lib": "static-1.2357",
  "developer-experience-shared-components": "static-1.10785",
  "purchase-motions-components": "static-1.6338",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.10185",
  "usage-tracker-anonymous": "static-1.6053",
  "usage-tracker-public": "static-1.7447",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3981",
  "reference-resolvers": "static-1.8462",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4198",
  "hubspot-apollo-cache": "static-1.618",
  "universal-page-editor-lib": "static-1.3288",
  "final-form": "static-1.76",
  "redux-toolkit": "static-1.76",
  "simple-data-table": "static-1.3500",
  "atom": "static-1.5366",
  "merchandise-lib": "static-1.276",
  "salesImages": "static-1.544",
  "ui-addon-draggable": "static-3.5039",
  "content-assistance-lib": "static-1.8174",
  "content-media-capture": "static-1.5394",
  "customer-data-ui-utilities": "static-1.10109",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24446",
  "growth-payments-core": "static-1.26145",
  "knowledge-content-types": "static-1.8638",
  "PatternValidationJS": "static-1.3175",
  "payment-link-components": "static-1.24138",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20279",
  "ui-addon-emoji-picker": "static-1.10166",
  "ui-business-units-lib": "static-1.9367",
  "video-components-external": "static-1.12120",
  "video-data-lib": "static-1.35778",
  "navigation-messaging": "static-1.8121",
  "collaboration-sidebar": "static-1.58685",
  "crm-component-utils": "static-1.39800",
  "crm-properties-common-lib": "static-1.6170",
  "customer-data-properties": "static-1.52528",
  "external-options-client-types": "static-1.4325",
  "framework-data-schema-resolvers": "static-1.7173",
  "property-value-citations": "static-1.3142",
  "reference-resolvers-lite": "static-1.8382",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10584",
  "base-ui": "static-1.20",
  "react-day-picker": "static-1.8",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5095",
  "content-icons-ui": "static-1.2344",
  "idb-keyval": "static-1.49",
  "reactive-lib": "static-1.1000",
  "breeze-artifacts-sdk": "static-1.275",
  "onboarding-journeys-lib": "static-1.885",
  "conversations-skeleton-state": "static-1.7526",
  "crm-message-bus": "static-1.43721",
  "customer-data-filters-ui-msw-helpers": "static-1.23300",
  "events-data-lib": "static-1.524",
  "FormUrlGenerator": "static-2.5008",
  "framework-builder-read-service-client": "static-1.4207",
  "hs-resources": "static-1.473",
  "multi-account-reference-resolvers": "static-1.1283",
  "onboarding-scopes": "static-1.6735",
  "onboarding-tours": "static-1.17090",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14431",
  "academy-common-lib": "static-1.14934",
  "dashboard-lib": "static-1.82756",
  "getting-started-shared-tasks": "static-1.19200",
  "hubspot-prosemirror-plugins": "static-1.18928",
  "share-with-third-party-component-lib": "static-1.8986",
  "ui-asset-management-lib": "static-1.11378",
  "user-context": "static-1.5400",
  "reporting-plugins": "static-1.10722",
  "reporting-reports": "static-1.68429",
  "hubs-service-types": "static-1.1538",
  "purchase-motions-api": "static-1.6341",
  "signup-constants": "static-1.19594",
  "nest": "static-1.516",
  "breeze-engine-chat-components": "static-1.660",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.185",
  "framework-listing-lib": "static-2.29457",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31387",
  "apps-service-types": "static-1.4020",
  "oauth-service-types": "static-1.4518",
  "signup-ui-url-generator": "static-2.8342",
  "onboarding-tours-client": "static-1.5305",
  "one-click-checkout": "static-1.356",
  "platform-infra-nav-components": "static-1.7879",
  "subscription-experience-data-types": "static-1.15235",
  "crm-record-cards-service-types": "static-1.3772",
  "location-customization-utils-lib": "static-1.10063",
  "redux-thunk": "static-2.78",
  "react-flip-move": "static-1.76",
  "ui-coaching-tips": "static-1.29272",
  "content-media-composition-data-lib": "static-1.13198",
  "fix-webm-duration": "static-1.28",
  "notification-sounds": "static-1.4706",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.681",
  "ui-addon-opt": "static-4.8644",
  "commerce-tours-lib": "static-1.6588",
  "growth-onboarding-reliability": "static-1.5361",
  "sales-checkout-service-client": "static-1.3811",
  "data-token-picker": "static-1.16861",
  "FileManagerLib": "static-1.40086",
  "content-media-compositions": "static-2.17205",
  "media-bridge-lib": "static-1.19380",
  "chatspot-widget-iframe": "static-1.22905",
  "collaboration-sidebar-common": "static-1.3482",
  "marketing-platform-lib": "static-1.7150",
  "card-properties-lib": "static-1.44974",
  "commerce-subscription-lib": "static-1.37741",
  "crm-actions": "static-1.6633",
  "crm-cards-sdk": "static-1.44515",
  "customer-data-properties-shared-msw-handlers": "static-1.9913",
  "customer-data-tracking": "static-1.7162",
  "calling-global-api": "static-1.65549",
  "calling-internal-common": "static-1.31598",
  "calling-lifecycle-internal": "static-1.66931",
  "calling-lifecycle-messages": "static-1.59225",
  "commerce-products-lib": "static-1.10494",
  "conditional-properties-service-client": "static-1.3998",
  "crm-index-visualization-core": "static-1.4519",
  "crm-links": "static-1.6610",
  "crm-pipelines-api-client-types": "static-1.4333",
  "formula-editor": "static-1.14726",
  "google-libphonenumber": "static-1.43",
  "inbounddb-objects-service-types": "static-1.4412",
  "meetings-icalendar-utils-lib": "static-1.916",
  "multi-currency-client-types": "static-1.3894",
  "object-builder-ui-client": "static-1.49629",
  "pipeline-validation-client-types": "static-1.4167",
  "smart-data-capture-core": "static-1.104",
  "smart-property-lib": "static-1.8250",
  "tiered-pricing": "static-1.1925",
  "topics-actions-lib": "static-1.445",
  "ui-addon-form-validation": "static-1.11263",
  "zustand": "static-1.83",
  "fdsr-migration-layer": "static-1.292",
  "framework-data-schema-quick-fetch": "static-1.7078",
  "restore-request-side-panel-lib": "static-1.1632",
  "growth-data-modal": "static-1.5867",
  "growth-onboarding-confetti": "static-1.3342",
  "growth-onboarding-next-action-utils": "static-1.2654",
  "onboarding-tours-utils": "static-1.1157",
  "ui-shepherd-tracker": "static-1.7930",
  "academy-service-client": "static-1.3968",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39945",
  "SafeStorage": "static-1.4683",
  "video-embed": "static-1.36612",
  "redux-actions": "static-3.69",
  "EmailSignatureEditor": "static-1.24972",
  "viral-links-lib": "static-1.7356",
  "nested-table": "static-1.515",
  "timezone-utils": "static-2.5526",
  "getting-started-shared-tasks-store": "static-1.18318",
  "campaign-roi-lib": "static-1.10149",
  "campaigns-utils-lib": "static-1.3486",
  "ui-addon-calendars": "static-2.5610",
  "customer-data-views-management": "static-1.25989",
  "framework-data-table": "static-2.12513",
  "nudge-client-utils": "static-1.3127",
  "nudge-custom-ui-functions": "static-1.1463",
  "switchboard-lib": "static-1.496",
  "access-check-ui-lib": "static-1.1549",
  "app-users-service-client": "static-1.5899",
  "app-users-service-types": "static-1.5307",
  "mini-checkout-client": "static-1.27451",
  "onboarding-utils": "static-1.5646",
  "permissions-shared-i18n-strings-fe": "static-1.2119",
  "ui-coaching-tips-shared-config": "static-1.29257",
  "checkout-sdk": "static-3.24294",
  "payment-method-components": "static-1.7130",
  "touchless-buying-components": "static-1.6162",
  "upgrade-catalog-service-types": "static-1.3751",
  "edison-service-client-types": "static-1.673",
  "growth-onboarding-feedback-components": "static-1.6865",
  "audio-components": "static-1.6316",
  "FileManagerImages": "static-1.37597",
  "video-components": "static-1.14122",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92788",
  "customer-data-sidebar": "static-2.46704",
  "enrichment-lib": "static-1.292",
  "ui-addon-draggable-compat": "static-2.4546",
  "universal-record-utils-lib": "static-1.1839",
  "commerce-billing-lib": "static-1.20127",
  "commerce-shared-components-lib": "static-1.19190",
  "commerce-tools-ui-lib": "static-1.11011",
  "crm-fe-perf": "static-1.23183",
  "calling-error-reporting": "static-1.31605",
  "shared-worker-versioning": "static-1.11321",
  "calling-usage-tracker": "static-1.6817",
  "voice-sms-access-library": "static-1.1989",
  "commerce-permissions": "static-1.1058",
  "products-iframe-lib": "static-1.8556",
  "products-ui-components-shared-msw-handlers": "static-1.10968",
  "crm-index-associations-lib": "static-1.6723",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10669",
  "sales-views-client-types": "static-1.4537",
  "bark-lib": "static-1.16793",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.622",
  "policy-lib": "static-1.7082",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10732",
  "onboarding-data-sync-lib": "static-1.2481",
  "growth-onboarding-next-action-components": "static-1.2682",
  "user-context-client": "static-1.4789",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.59",
  "urlinator": "static-1.4813",
  "outpost": "static-1.4438",
  "draft-convert": "static-2.78",
  "draft-extend": "static-3.81",
  "draft-js": "static-5.83",
  "draft-plugins": "static-2.22131",
  "sales-email-signature-service-client": "static-1.4125",
  "ts-utils-lib": "static-1.430",
  "crm-export-dialog": "static-1.6563",
  "crm-view-components": "static-1.1075",
  "react-beautiful-dnd": "static-1.68",
  "customer-data-associations": "static-1.7607",
  "tasks-actions-lib": "static-1.89",
  "nudge-custom-function-registry": "static-1.2884",
  "nudge-renderer-utils": "static-1.3203",
  "whisper-core-api": "static-1.7290",
  "InboxConnectUtils": "static-4.15525",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46806",
  "hub-http-rxjs": "static-1.839",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4270",
  "company-details-components": "static-1.6483",
  "react-performance-metrics-lib": "static-1.835",
  "pricing-pages-ui-components": "static-1.15725",
  "quote-checkout-service-types": "static-1.3734",
  "social-insights-client-types": "static-1.22703",
  "crm_universal": "static-1.22471",
  "customer-data-email": "static-1.18500",
  "card-payment-highlight-lib": "static-1.37942",
  "commerce-contract-lib": "static-1.13270",
  "invoices-highlight-card-lib": "static-1.55685",
  "orders-highlight-card-lib": "static-1.22159",
  "products-highlight-card-lib": "static-1.18777",
  "quotes-highlight-card-lib": "static-1.72797",
  "crm-source-interpretation-lib": "static-1.5609",
  "data-agent-utils": "static-1.354",
  "crm-object-search-query-utilities": "static-1.10163",
  "utility-belt": "static-1.2814",
  "payments-enrollment-embed-lib": "static-1.23762",
  "stripe-embedded-components": "static-1.7971",
  "customer-data-rte": "static-1.33616",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6244",
  "payments-post-enroll-local-storage-lib": "static-1.5386",
  "qrcode-generator": "static-1.74",
  "quotes-client-types": "static-1.38887",
  "calling-orchestration-schema": "static-1.36766",
  "react-reducer-toolkit": "static-1.16330",
  "meetings-connect-utils-lib": "static-1.7889",
  "hub-http-contrib": "static-1.3319",
  "ui-addon-sales-email": "static-1.5493",
  "access-control-lib": "static-1.10716",
  "EmailComponents": "static-1.55513",
  "EmailData": "static-1.54191",
  "redux-less": "static-2.9759",
  "company-details-service-types": "static-1.4220",
  "segments-query-core": "static-1.1703",
  "pricing-pages-api": "static-1.15590",
  "sequences-lib": "static-1.8509",
  "ui-gdpr-components": "static-1.10625",
  "products-ui-components": "static-1.41012",
  "accounting-integrations-ui-components": "static-1.7509",
  "invoices-ui-lib": "static-1.55701",
  "commerce-products-api": "static-1.2669",
  "invoices-iframe-lib": "static-1.57759",
  "quotes-modal-lib": "static-1.103475",
  "quotes-ui-lib": "static-1.81518",
  "stripe-connect-js": "static-1.75",
  "draft-content-plugins": "static-1.28874",
  "ContentComponents": "static-2.72046",
  "ContentData": "static-1.69165",
  "marketing-contacts-lib": "static-1.10981",
  "marketing-email-service-types": "static-1.2081",
  "messaging-editing-lib": "static-1.47095",
  "messaging-usage-based-billing-components-lib": "static-1.1957",
  "automation-ui-source-apps": "static-1.19651",
  "automation-ui-types": "static-1.20569",
  "messaging-types-lib": "static-1.46832",
  "onboarding-settings-client": "static-1.4789",
  "sequences-client-types-lib": "static-1.8366",
  "commerce-tax-lib": "static-1.818",
  "price-books-api": "static-1.1700",
  "price-books-components": "static-1.1758",
  "property-description-translator": "static-1.4121",
  "ramp-editor": "static-1.859",
  "commerce-analytics-service-client": "static-1.3799",
  "totals-ui-components": "static-1.24260",
  "SalesContentIndexUI": "static-3.9603",
  "advanced-menus-core": "static-1.15550",
  "advanced-menus-lib": "static-1.12427",
  "automation-ui-ubb": "static-1.6485",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7617",
  "data-token-views": "static-1.16842",
  "forms-utils-lib": "static-1.13068",
  "payments-embed-points-lib": "static-1.13558",
  "react-tinymce": "static-1.55942",
  "simple-menus-core": "static-1.15549",
  "simple-menus-lib": "static-1.17066",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55068",
  "tinymce-data": "static-1.41153",
  "tinymce-plugins": "static-1.58182",
  "tinymce-themes": "static-1.57038",
  "ui-brand-identity-lib": "static-1.16411",
  "ui-memberships-settings-lib": "static-1.34807",
  "videoconference-integration-components": "static-1.7233",
  "marketing-contacts-client": "static-1.7791",
  "mc-hard-limits-client-types": "static-1.185",
  "automation-applications-service-types": "static-1.3651",
  "automation-platform-service-types": "static-1.2662",
  "ContentEditorUI": "static-2.77869",
  "short-messages-app-service-client": "static-1.4194",
  "web-interactives-components": "static-1.14221",
  "web-interactives-data": "static-1.14222",
  "messaging-shared-utils-lib": "static-1.1406",
  "messaging-user-info-utils-lib": "static-1.1576",
  "email-portal-health-service-types": "static-1.1260",
  "line-items-api": "static-1.1071",
  "commerce-totals-service-types": "static-1.4018",
  "FireAlarmUi": "static-1.4706",
  "sales-templates-service-types-lib": "static-1.4370",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22505",
  "automation-ui-usage-tracking": "static-1.21968",
  "data-studio-ubb": "static-1.3475",
  "interframe": "static-3.5036",
  "layout-dnd-components": "static-1.12938",
  "layout-dnd-utils": "static-1.11913",
  "NamespacedHubStyle": "static-2.9249",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27618",
  "content-management-data-lib": "static-1.5928",
  "copilot-plugins": "static-1.11792",
  "cta-picker": "static-1.37051",
  "customer-agent-discovery-components-lib": "static-1.3882",
  "editor-components": "static-1.13624",
  "editor-iframe-lib": "static-1.8772",
  "error-messaging-js": "static-1.5477",
  "FormsCommonComponents": "static-1.86525",
  "layout-data-lib": "static-1.10238",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.71",
  "redux-request-state": "static-1.10929",
  "SharedLegalStrings": "static-1.2027",
  "smart-content-core": "static-1.43141",
  "smart-content-lib": "static-1.43794",
  "social-composer-lib": "static-1.60240",
  "structured-content-lib": "static-1.25883",
  "theme-previewer-lib": "static-1.53911",
  "tinymce-copilot": "static-1.17136",
  "xray-recommendation-lib": "static-1.8240",
  "automation-ui-routing": "static-1.21926",
  "sql-reporting-client-types": "static-1.5880",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42760",
  "reporting-enablement": "static-1.23796",
  "forms-ai-lib": "static-1.4737",
  "codemirror-dlb": "static-1.59428",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6719",
  "report-customization-components": "static-1.13877",
  "data-quality-ui-library": "static-1.13762",
  "reporting-filters": "static-1.972",
  "reporting-insights-lib": "static-1.2533",
  "segments-client-types": "static-1.11469"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13193",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.717",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9937",
  "foundations-components": "/foundations-components/static-1.8463",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1488",
  "foundations-theming": "/foundations-theming/static-1.4753",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.87",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8313",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10586",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11767",
  "I18n": "/I18n/static-7.1669",
  "jasmine-runner": "/jasmine-runner/static-1.6733",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.606",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13256",
  "quartz": "/quartz/static-1.7432",
  "react-dlb": "/react-dlb/static-1.88",
  "react-rhumb": "/react-rhumb/static-1-aeastham-wv-soft-nav-lcp-field-cleanup.2",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3136",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10685",
  "reselect": "/reselect/static-3.10",
  "settings-ui-lib": "/settings-ui-lib/static-1.12804",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7602",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11427",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9818",
  "unified-auth": "/unified-auth/static-1.883",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1165",
  "usage-tracker": "/usage-tracker/static-1.7636",
  "usage-tracker-core": "/usage-tracker-core/static-1.7486",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8383",
  "hub-http": "/hub-http/static-1.6493",
  "integrations-lib": "/integrations-lib/static-1.16993",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20692",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.678",
  "property-management-iframe": "/property-management-iframe/static-1.14096",
  "quartz-config": "/quartz-config/static-1.1210",
  "quartz-core": "/quartz-core/static-1.6651",
  "quartz-routing": "/quartz-routing/static-1.862",
  "quick-fetch": "/quick-fetch/static-1.4117",
  "react": "/react/static-7.192",
  "rpc-client-utils": "/rpc-client-utils/static-1.4946",
  "ts-schema": "/ts-schema/static-1.4279",
  "ui-universal-auth": "/ui-universal-auth/static-1.9369",
  "UIComponents": "/UIComponents/static-3.8713",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3606",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3709",
  "quartz-webpack": "/quartz-webpack/static-1.3656",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.510",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9674",
  "codemirror": "/codemirror/static-5.100",
  "foundations-assets": "/foundations-assets/static-1.5164",
  "pulse": "/pulse/static-1.909",
  "react-codemirror": "/react-codemirror/static-1.10920",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.571",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4732",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2469",
  "framer-motion": "/framer-motion/static-1.77",
  "hs-story-utils": "/hs-story-utils/static-1.9706",
  "react-aria": "/react-aria/static-1.71",
  "react-create-root-preference": "/react-create-root-preference/static-1.68",
  "react-select-plus": "/react-select-plus/static-1.110",
  "react-utils": "/react-utils/static-2.5542",
  "react-virtualized": "/react-virtualized/static-2.105",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2587",
  "ui-fonts": "/ui-fonts/static-1.1029",
  "ui-images": "/ui-images/static-2.1239",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3236",
  "foundations-theming-base": "/foundations-theming-base/static-1.3738",
  "stylex": "/stylex/static-1.39",
  "HeadJS": "/HeadJS/static-2.794",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3424",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.157",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.89",
  "jasmine": "/jasmine/static-4.4594",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8983",
  "ai-rendering-library": "/ai-rendering-library/static-1.11067",
  "chirp-fetch": "/chirp-fetch/static-1.2175",
  "connections-embed-lib": "/connections-embed-lib/static-1.1484",
  "copilot-toolkit": "/copilot-toolkit/static-1.11820",
  "feedback-loader": "/feedback-loader/static-1.29781",
  "laboratory-lib": "/laboratory-lib/static-3.7431",
  "marketplace-embed": "/marketplace-embed/static-1.22870",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10587",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20647",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14862",
  "sanitize-text": "/sanitize-text/static-1.8434",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6050",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5322",
  "wootric-nps": "/wootric-nps/static-1.7186",
  "quartz-head": "/quartz-head/static-1.1097",
  "web-vitals": "/web-vitals/static-1.13",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4936",
  "immer": "/immer/static-1.99",
  "immerable": "/immerable/static-1.4430",
  "highcharts": "/highcharts/static-8.109",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2672",
  "reporting-data": "/reporting-data/static-1.68752",
  "cssUtils": "/cssUtils/static-1.901",
  "flux-actions": "/flux-actions/static-1.366",
  "react-colorpicker": "/react-colorpicker/static-2.10497",
  "react-dnd-compat": "/react-dnd-compat/static-1.4898",
  "redux-observable": "/redux-observable/static-1.73",
  "ReduxMessenger": "/ReduxMessenger/static-2.10650",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7626",
  "icons": "/icons/static-2.678",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19224",
  "storybook-react": "/storybook-react/static-1.38",
  "trellis-story-utils": "/trellis-story-utils/static-1.4789",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5946",
  "quartz-i18n": "/quartz-i18n/static-1.1107",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.428",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1259",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.994",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.104",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.437",
  "slack-ui-library": "/slack-ui-library/static-1.10680",
  "fsm": "/fsm/static-1.4030",
  "customer-data-objects": "/customer-data-objects/static-1.7971",
  "property-translator": "/property-translator/static-1.5678",
  "hs-locale-management": "/hs-locale-management/static-1.279",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8203",
  "hs-promise-utils": "/hs-promise-utils/static-1.5877",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5159",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14408",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5889",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8059",
  "sanitize": "/sanitize/static-1.4754",
  "superstore": "/superstore/static-1.5037",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10549",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8300",
  "hub-http-janus": "/hub-http-janus/static-1.875",
  "hubspotter-http": "/hubspotter-http/static-1.4850",
  "immutable-less": "/immutable-less/static-1.4930",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18099",
  "nav-meta": "/nav-meta/static-1.30431",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18355",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.992",
  "ai-studio-lib": "/ai-studio-lib/static-1.12419",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18936",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.457",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9358",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8306",
  "ui-product-approvals": "/ui-product-approvals/static-1.29097",
  "ui-tool-access": "/ui-tool-access/static-1.10435",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4042",
  "property-management-common": "/property-management-common/static-1.6384",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.50",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.31",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.425",
  "quartz-auth": "/quartz-auth/static-1.1107",
  "quartz-test": "/quartz-test/static-1.1107",
  "quartz-tracking": "/quartz-tracking/static-1.811",
  "trellis-components": "/trellis-components/static-1.2606",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.356",
  "HubStyle": "/HubStyle/static-2.12074",
  "bender-build-tools": "/bender-build-tools/static-1.3425",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22914",
  "ContentUtils": "/ContentUtils/static-1.69090",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13312",
  "sassPrefix": "/sassPrefix/static-1.173",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.412",
  "batch-promise": "/batch-promise/static-1.1824",
  "event-emitter": "/event-emitter/static-1.1233",
  "fast-json-patch": "/fast-json-patch/static-1.68",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5739",
  "magpie-types": "/magpie-types/static-1.5199",
  "stylex-utils": "/stylex-utils/static-1.138",
  "trellis-theming": "/trellis-theming/static-1.1255",
  "avatar-components": "/avatar-components/static-1.2766",
  "breeze-engine-core": "/breeze-engine-core/static-1.960",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.680",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40865",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13459",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15474",
  "ExportDialog": "/ExportDialog/static-6.10658",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.47",
  "highlight.js": "/highlight.js/static-1.84",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42004",
  "reporting-snowflake": "/reporting-snowflake/static-1.57369",
  "reporting-ui-components": "/reporting-ui-components/static-2.66022",
  "reporting-visualizations": "/reporting-visualizations/static-1.60827",
  "trial-components-library": "/trial-components-library/static-1.14079",
  "ui-addon-teams": "/ui-addon-teams/static-1.21887",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.493",
  "navigation-components": "/navigation-components/static-1.18794",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1682",
  "simple-logging-lib": "/simple-logging-lib/static-1.3331",
  "fail-safe": "/fail-safe/static-1.234",
  "app-governance-lib": "/app-governance-lib/static-1.2357",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10785",
  "purchase-motions-components": "/purchase-motions-components/static-1.6338",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10185",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6053",
  "usage-tracker-public": "/usage-tracker-public/static-1.7447",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3981",
  "reference-resolvers": "/reference-resolvers/static-1.8462",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4198",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.618",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3288",
  "final-form": "/final-form/static-1.76",
  "redux-toolkit": "/redux-toolkit/static-1.76",
  "simple-data-table": "/simple-data-table/static-1.3500",
  "atom": "/atom/static-1.5366",
  "merchandise-lib": "/merchandise-lib/static-1.276",
  "salesImages": "/salesImages/static-1.544",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5039",
  "content-assistance-lib": "/content-assistance-lib/static-1.8174",
  "content-media-capture": "/content-media-capture/static-1.5394",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10109",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24446",
  "growth-payments-core": "/growth-payments-core/static-1.26145",
  "knowledge-content-types": "/knowledge-content-types/static-1.8638",
  "PatternValidationJS": "/PatternValidationJS/static-1.3175",
  "payment-link-components": "/payment-link-components/static-1.24138",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20279",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10166",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9367",
  "video-components-external": "/video-components-external/static-1.12120",
  "video-data-lib": "/video-data-lib/static-1.35778",
  "navigation-messaging": "/navigation-messaging/static-1.8121",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58685",
  "crm-component-utils": "/crm-component-utils/static-1.39800",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6170",
  "customer-data-properties": "/customer-data-properties/static-1.52528",
  "external-options-client-types": "/external-options-client-types/static-1.4325",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7173",
  "property-value-citations": "/property-value-citations/static-1.3142",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8382",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10584",
  "base-ui": "/base-ui/static-1.20",
  "react-day-picker": "/react-day-picker/static-1.8",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5095",
  "content-icons-ui": "/content-icons-ui/static-1.2344",
  "idb-keyval": "/idb-keyval/static-1.49",
  "reactive-lib": "/reactive-lib/static-1.1000",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.275",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.885",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7526",
  "crm-message-bus": "/crm-message-bus/static-1.43721",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23300",
  "events-data-lib": "/events-data-lib/static-1.524",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5008",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4207",
  "hs-resources": "/hs-resources/static-1.473",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1283",
  "onboarding-scopes": "/onboarding-scopes/static-1.6735",
  "onboarding-tours": "/onboarding-tours/static-1.17090",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14431",
  "academy-common-lib": "/academy-common-lib/static-1.14934",
  "dashboard-lib": "/dashboard-lib/static-1.82756",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19200",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18928",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8986",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11378",
  "user-context": "/user-context/static-1.5400",
  "reporting-plugins": "/reporting-plugins/static-1.10722",
  "reporting-reports": "/reporting-reports/static-1.68429",
  "hubs-service-types": "/hubs-service-types/static-1.1538",
  "purchase-motions-api": "/purchase-motions-api/static-1.6341",
  "signup-constants": "/signup-constants/static-1.19594",
  "nest": "/nest/static-1.516",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.660",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.185",
  "framework-listing-lib": "/framework-listing-lib/static-2.29457",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31387",
  "apps-service-types": "/apps-service-types/static-1.4020",
  "oauth-service-types": "/oauth-service-types/static-1.4518",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8342",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5305",
  "one-click-checkout": "/one-click-checkout/static-1.356",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7879",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15235",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3772",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10063",
  "redux-thunk": "/redux-thunk/static-2.78",
  "react-flip-move": "/react-flip-move/static-1.76",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29272",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13198",
  "fix-webm-duration": "/fix-webm-duration/static-1.28",
  "notification-sounds": "/notification-sounds/static-1.4706",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.681",
  "ui-addon-opt": "/ui-addon-opt/static-4.8644",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6588",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5361",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3811",
  "data-token-picker": "/data-token-picker/static-1.16861",
  "FileManagerLib": "/FileManagerLib/static-1.40086",
  "content-media-compositions": "/content-media-compositions/static-2.17205",
  "media-bridge-lib": "/media-bridge-lib/static-1.19380",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22905",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3482",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7150",
  "card-properties-lib": "/card-properties-lib/static-1.44974",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37741",
  "crm-actions": "/crm-actions/static-1.6633",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44515",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9913",
  "customer-data-tracking": "/customer-data-tracking/static-1.7162",
  "calling-global-api": "/calling-global-api/static-1.65549",
  "calling-internal-common": "/calling-internal-common/static-1.31598",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66931",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59225",
  "commerce-products-lib": "/commerce-products-lib/static-1.10494",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3998",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4519",
  "crm-links": "/crm-links/static-1.6610",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4333",
  "formula-editor": "/formula-editor/static-1.14726",
  "google-libphonenumber": "/google-libphonenumber/static-1.43",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4412",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.916",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3894",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49629",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4167",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.104",
  "smart-property-lib": "/smart-property-lib/static-1.8250",
  "tiered-pricing": "/tiered-pricing/static-1.1925",
  "topics-actions-lib": "/topics-actions-lib/static-1.445",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11263",
  "zustand": "/zustand/static-1.83",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.292",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7078",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1632",
  "growth-data-modal": "/growth-data-modal/static-1.5867",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3342",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2654",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1157",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7930",
  "academy-service-client": "/academy-service-client/static-1.3968",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39945",
  "SafeStorage": "/SafeStorage/static-1.4683",
  "video-embed": "/video-embed/static-1.36612",
  "redux-actions": "/redux-actions/static-3.69",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24972",
  "viral-links-lib": "/viral-links-lib/static-1.7356",
  "nested-table": "/nested-table/static-1.515",
  "timezone-utils": "/timezone-utils/static-2.5526",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18318",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10149",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3486",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5610",
  "customer-data-views-management": "/customer-data-views-management/static-1.25989",
  "framework-data-table": "/framework-data-table/static-2.12513",
  "nudge-client-utils": "/nudge-client-utils/static-1.3127",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1463",
  "switchboard-lib": "/switchboard-lib/static-1.496",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1549",
  "app-users-service-client": "/app-users-service-client/static-1.5899",
  "app-users-service-types": "/app-users-service-types/static-1.5307",
  "mini-checkout-client": "/mini-checkout-client/static-1.27451",
  "onboarding-utils": "/onboarding-utils/static-1.5646",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2119",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29257",
  "checkout-sdk": "/checkout-sdk/static-3.24294",
  "payment-method-components": "/payment-method-components/static-1.7130",
  "touchless-buying-components": "/touchless-buying-components/static-1.6162",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3751",
  "edison-service-client-types": "/edison-service-client-types/static-1.673",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6865",
  "audio-components": "/audio-components/static-1.6316",
  "FileManagerImages": "/FileManagerImages/static-1.37597",
  "video-components": "/video-components/static-1.14122",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92788",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46704",
  "enrichment-lib": "/enrichment-lib/static-1.292",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4546",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1839",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20127",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19190",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11011",
  "crm-fe-perf": "/crm-fe-perf/static-1.23183",
  "calling-error-reporting": "/calling-error-reporting/static-1.31605",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11321",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6817",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1989",
  "commerce-permissions": "/commerce-permissions/static-1.1058",
  "products-iframe-lib": "/products-iframe-lib/static-1.8556",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10968",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6723",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10669",
  "sales-views-client-types": "/sales-views-client-types/static-1.4537",
  "bark-lib": "/bark-lib/static-1.16793",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.622",
  "policy-lib": "/policy-lib/static-1.7082",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10732",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2481",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2682",
  "user-context-client": "/user-context-client/static-1.4789",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.59",
  "urlinator": "/urlinator/static-1.4813",
  "outpost": "/outpost/static-1.4438",
  "draft-convert": "/draft-convert/static-2.78",
  "draft-extend": "/draft-extend/static-3.81",
  "draft-js": "/draft-js/static-5.83",
  "draft-plugins": "/draft-plugins/static-2.22131",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4125",
  "ts-utils-lib": "/ts-utils-lib/static-1.430",
  "crm-export-dialog": "/crm-export-dialog/static-1.6563",
  "crm-view-components": "/crm-view-components/static-1.1075",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.68",
  "customer-data-associations": "/customer-data-associations/static-1.7607",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.89",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2884",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3203",
  "whisper-core-api": "/whisper-core-api/static-1.7290",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15525",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46806",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.839",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4270",
  "company-details-components": "/company-details-components/static-1.6483",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.835",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15725",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3734",
  "social-insights-client-types": "/social-insights-client-types/static-1.22703",
  "crm_universal": "/crm_universal/static-1.22471",
  "customer-data-email": "/customer-data-email/static-1.18500",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37942",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13270",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55685",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22159",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18777",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72797",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5609",
  "data-agent-utils": "/data-agent-utils/static-1.354",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10163",
  "utility-belt": "/utility-belt/static-1.2814",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23762",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7971",
  "customer-data-rte": "/customer-data-rte/static-1.33616",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6244",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5386",
  "qrcode-generator": "/qrcode-generator/static-1.74",
  "quotes-client-types": "/quotes-client-types/static-1.38887",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36766",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16330",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7889",
  "hub-http-contrib": "/hub-http-contrib/static-1.3319",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5493",
  "access-control-lib": "/access-control-lib/static-1.10716",
  "EmailComponents": "/EmailComponents/static-1.55513",
  "EmailData": "/EmailData/static-1.54191",
  "redux-less": "/redux-less/static-2.9759",
  "company-details-service-types": "/company-details-service-types/static-1.4220",
  "segments-query-core": "/segments-query-core/static-1.1703",
  "pricing-pages-api": "/pricing-pages-api/static-1.15590",
  "sequences-lib": "/sequences-lib/static-1.8509",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "products-ui-components": "/products-ui-components/static-1.41012",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7509",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55701",
  "commerce-products-api": "/commerce-products-api/static-1.2669",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57759",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103475",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81518",
  "stripe-connect-js": "/stripe-connect-js/static-1.75",
  "draft-content-plugins": "/draft-content-plugins/static-1.28874",
  "ContentComponents": "/ContentComponents/static-2.72046",
  "ContentData": "/ContentData/static-1.69165",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10981",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2081",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47095",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1957",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19651",
  "automation-ui-types": "/automation-ui-types/static-1.20569",
  "messaging-types-lib": "/messaging-types-lib/static-1.46832",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4789",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8366",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.818",
  "price-books-api": "/price-books-api/static-1.1700",
  "price-books-components": "/price-books-components/static-1.1758",
  "property-description-translator": "/property-description-translator/static-1.4121",
  "ramp-editor": "/ramp-editor/static-1.859",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3799",
  "totals-ui-components": "/totals-ui-components/static-1.24260",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9603",
  "advanced-menus-core": "/advanced-menus-core/static-1.15550",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12427",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6485",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7617",
  "data-token-views": "/data-token-views/static-1.16842",
  "forms-utils-lib": "/forms-utils-lib/static-1.13068",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13558",
  "react-tinymce": "/react-tinymce/static-1.55942",
  "simple-menus-core": "/simple-menus-core/static-1.15549",
  "simple-menus-lib": "/simple-menus-lib/static-1.17066",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55068",
  "tinymce-data": "/tinymce-data/static-1.41153",
  "tinymce-plugins": "/tinymce-plugins/static-1.58182",
  "tinymce-themes": "/tinymce-themes/static-1.57038",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16411",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34807",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7233",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7791",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.185",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3651",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2662",
  "ContentEditorUI": "/ContentEditorUI/static-2.77869",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4194",
  "web-interactives-components": "/web-interactives-components/static-1.14221",
  "web-interactives-data": "/web-interactives-data/static-1.14222",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1406",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1576",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1260",
  "line-items-api": "/line-items-api/static-1.1071",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4018",
  "FireAlarmUi": "/FireAlarmUi/static-1.4706",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4370",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22505",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21968",
  "data-studio-ubb": "/data-studio-ubb/static-1.3475",
  "interframe": "/interframe/static-3.5036",
  "layout-dnd-components": "/layout-dnd-components/static-1.12938",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11913",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9249",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27618",
  "content-management-data-lib": "/content-management-data-lib/static-1.5928",
  "copilot-plugins": "/copilot-plugins/static-1.11792",
  "cta-picker": "/cta-picker/static-1.37051",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3882",
  "editor-components": "/editor-components/static-1.13624",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8772",
  "error-messaging-js": "/error-messaging-js/static-1.5477",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86525",
  "layout-data-lib": "/layout-data-lib/static-1.10238",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.71",
  "redux-request-state": "/redux-request-state/static-1.10929",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2027",
  "smart-content-core": "/smart-content-core/static-1.43141",
  "smart-content-lib": "/smart-content-lib/static-1.43794",
  "social-composer-lib": "/social-composer-lib/static-1.60240",
  "structured-content-lib": "/structured-content-lib/static-1.25883",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53911",
  "tinymce-copilot": "/tinymce-copilot/static-1.17136",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8240",
  "automation-ui-routing": "/automation-ui-routing/static-1.21926",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5880",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42760",
  "reporting-enablement": "/reporting-enablement/static-1.23796",
  "forms-ai-lib": "/forms-ai-lib/static-1.4737",
  "codemirror-dlb": "/codemirror-dlb/static-1.59428",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6719",
  "report-customization-components": "/report-customization-components/static-1.13877",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13762",
  "reporting-filters": "/reporting-filters/static-1.972",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2533",
  "segments-client-types": "/segments-client-types/static-1.11469"
}
};
